import React, { useEffect, useState } from 'react';
import i18n from 'i18n-react';
import PropTypes from 'prop-types';

const RewardSearch = ({ products, setSearch }) => {
  const [category, setCategory] = useState('');
  const [inputSearch, setInputSearch] = useState('');
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (options.length === 0 && products.length !== 0) {
      const select = [
        ...new Map(products.map(m => [m.category, m])).values(),
      ];
      setOptions(select);
      setCategory('0');
    }
  });

  const handleSearch = (inpSearch, inputCategory) => {
    const search = inpSearch.toUpperCase();
    const inpCategory = inputCategory.toUpperCase();

    setSearch(products.filter(e =>
      (inpCategory !== '0'
        ? e.category.toUpperCase().includes(inpCategory) &&
            e.title.toUpperCase().includes(search)
        : e.title.toUpperCase().includes(search))));
  };

  const submitSearch = (e) => {
    e.preventDefault();

    handleSearch(inputSearch, category);
  };

  return (
    <form className="rewardSearch">
      <div className="inputs">
        <div className="label">
          <div >Category</div>
        </div>
        <select
          onChange={(e) => { setCategory(e.target.value); handleSearch(inputSearch, e.target.value); }}
        >
          <option value="0">All categories</option>
          {options.map(e => (
            <option key={e.category} value={e.category}>
              {e.category}
            </option>
          ))}
        </select>
        <div className="label">
          <div>Title</div>
        </div>
        <input
          type="text"
          onChange={(e) => { setInputSearch(e.target.value); handleSearch(e.target.value, category); }
          }
        />
      </div>
      <button type="submit" className="btn" onClick={e => submitSearch(e)}>
        {i18n.translate('rewards.RewardSearch.button')}
      </button>
    </form>
  );
};

export default RewardSearch;

RewardSearch.propTypes = {
  products: PropTypes.arrayOf(PropTypes.objectOf).isRequired,
  setSearch: PropTypes.func.isRequired,
};

RewardSearch.defaultProps = {};
